import {
  EDIT_PROFILE_REQUEST,
  EDIT_PROFILE_SUCCESS,
  EDIT_PROFILE_FAILURE,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILURE,
  VERIFY_EMAIL_REQUEST,
  VERIFY_EMAIL_SUCCESS,
  VERIFY_EMAIL_FAILURE,
  VERIFY_TOKEN_REQUEST,
  VERIFY_TOKEN_SUCCESS,
  VERIFY_TOKEN_FAILURE,
  CLEAR_PROFILE_MESSAGES,
  GET_PROFILE_REQUEST,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_FAILURE,
  SEND_EMAIL_REQUEST,
  SEND_EMAIL_SUCCESS,
  SEND_EMAIL_FAILURE,
} from "../constants/profileConstants";

const initialState = {
  loading: false,
  error: null,
  success: false,
  message: null,
  data: null,
  emailLoading: false,
  emailError: null,
  emailSuccess: false,
};

const profileReducer = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_PROFILE_REQUEST:
    case CHANGE_PASSWORD_REQUEST:
    case VERIFY_EMAIL_REQUEST:
    case VERIFY_TOKEN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };

    case EDIT_PROFILE_SUCCESS:
    case CHANGE_PASSWORD_SUCCESS:
    case VERIFY_EMAIL_SUCCESS:
    case VERIFY_TOKEN_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        message: action.payload.message || "Operation completed successfully",
      };

    case EDIT_PROFILE_FAILURE:
    case CHANGE_PASSWORD_FAILURE:
    case VERIFY_EMAIL_FAILURE:
    case VERIFY_TOKEN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };

    case CLEAR_PROFILE_MESSAGES:
      return {
        ...state,
        error: null,
        success: false,
        message: null,
      };
    // get Profile
    case GET_PROFILE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };

    case GET_PROFILE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case SEND_EMAIL_REQUEST:
      return {
        ...state,
        emailLoading: true,
        emailError: null,
        emailSuccess: false,
      };

    case SEND_EMAIL_SUCCESS:
      return {
        ...state,
        emailLoading: false,
        emailError: null,
        emailSuccess: true,
      };

    case SEND_EMAIL_FAILURE:
      return {
        ...state,
        emailLoading: false,
        emailError: action.payload,
      };

    default:
      return state;
  }
};

export default profileReducer;
